import { z } from "zod";

export const fossilEnergyTypeSchema = z.enum([
  "fuel",
  "diesel",
  "GPL",
  "GNV",
]);

export const electricEnergyTypeSchema = z.enum([
  "electric",
  "hybrideFuel",
  "hybrideDiesel",
]);

export const energyTypeSchema = z.enum([
  ...fossilEnergyTypeSchema.options,
  ...electricEnergyTypeSchema.options,
]);

export const fossilEnergyTypes = fossilEnergyTypeSchema.options;
export const electricEnergyTypes = electricEnergyTypeSchema.options;
export const energyTypes = energyTypeSchema.options;

export type FossilEnergyType = z.infer<typeof fossilEnergyTypeSchema>;
export type ElectricEnergyType = z.infer<typeof electricEnergyTypeSchema>;
export type EnergyType = z.infer<typeof energyTypeSchema>;
